import {CONFIG} from "../../constants";

export default class RecordSound {
  private mediaRecorder: MediaRecorder | null = null;
  private session: number = 0;
  private startTime: Date | null = null;
  private duration = 0;
  private recording = false;
  private onVolume: Function | null = null;

  constructor() {
    console.log("Initialized RecordSound");
  }

  start = (clientToken: string, recordingId: string, onStart: Function, onSendSound: Function,
           onVolume: Function) => {
    this.onVolume = onVolume;
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((mediaStream) => {
        // const stream = new MediaStream(mediaStream);
        const stream = new MediaStream();
        for (const track of mediaStream.getAudioTracks()) {
          console.log('Added track');
          console.log(track);
          stream.addTrack(track);
        }

        this.recording = true;
        this.measureVolume(stream);

        // https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.start(2000);

        const url = CONFIG.SYSTEM === "development" ?
          "http://localhost:8070/api/client/record_stream/" :
          "https://backoffice.zebrain.se/api/client/record_stream/"
        this.mediaRecorder.ondataavailable = (e) => {
          const formData = new FormData();
          if (this.startTime) {
            const now = new Date();
            this.duration = now.getTime() - this.startTime.getTime();
            onSendSound(this.duration);
          }

          formData.append('audio', e.data);
          formData.append('session', '' + this.session);
          formData.append('duration', this.duration.toFixed(1))
          fetch(url + recordingId, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + clientToken,
            },
            body: formData
          }).then(response => {
            console.log(response);

          })
        }

        this.mediaRecorder.onstart = (e => {
          onStart();
          this.startTime = new Date();
        });

        this.mediaRecorder.onstop = (e) => {
          this.session++;
          this.recording = false;
          if (this.startTime) {
            const now = new Date();
            this.duration = now.getTime() - this.startTime.getTime();
          }
          let url = CONFIG.SYSTEM === "development" ?
            "http://localhost:8070/api/client/record_stop/" :
            "https://backoffice.zebrain.se/api/client/record_stop/"
          url += recordingId + "?duration=" + this.duration;
          fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + clientToken,
            },
          }).then(response => {
            console.log(response);
          });
          stream.getTracks().forEach((track: MediaStreamTrack) => {
            if (track.readyState === 'live') {
              track.stop()
              console.log(track.kind + ' stopped')
            } else {
              console.log(track.kind + ': ' + track.readyState)
            }
          })
        }
      });
  }

  stop = () => {
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
    } else {
      console.log("Missing mediaRecorder");
    }
  }

  measureVolume = (stream: MediaStream) => {
    const audioContext = new AudioContext();
    const mediaStreamSource = audioContext.createMediaStreamSource(stream);
    const destination = audioContext.createMediaStreamDestination();
    const analyser = audioContext.createAnalyser();
    analyser.connect(destination);

    const audio = document.createElement('audio');
    audio.srcObject = destination.stream;
    audio.autoplay = false;
    mediaStreamSource.connect(destination);
    mediaStreamSource.connect(analyser);

    analyser.fftSize = 1024;

    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    requestAnimationFrame(() => {
      this.drawSound(analyser, bufferLength, dataArray);
    })
  }

  drawSound = (analyser: any, bufferLength: number, dataArray: Uint8Array) => {
    if (!this.recording) {
      return;
    }

    analyser.getByteFrequencyData(dataArray)
    let total = 0;
    for (let i = 0; i < bufferLength; i++) {
      total += dataArray[i];
    }

    let volume = Math.sqrt(total / bufferLength) * 8;
    if (this.onVolume) {
      this.onVolume(volume);
    }

    requestAnimationFrame(() => {
      this.drawSound(analyser, bufferLength, dataArray);
    })
  }

}